import React, { ReactElement } from "react"
import { bottomToTopItem } from "modules/shared/animations/variants"
import { FormProps } from "types/rating.types"
import { deliveryPreferenceData, relativeEvaluationData } from "modules/shared/datas/RatingDatas"
import {
  Message,
  MessageSpacing,
  MessageWidth,
  QuestionContainer,
  QuestionContainerV2,
  QuestionContainerV2Spacing,
  QuestionItemText,
  QuestionValues,
} from "modules/rating/screens/Rating.styled"

const CompetitivePreference = ({ ratingState, handleRatingUpdate, getAnimateProperties }: FormProps): ReactElement => {
  return (
    <>
      <MessageWidth>
        <MessageSpacing>
          <Message>{deliveryPreferenceData.title}</Message>
        </MessageSpacing>
      </MessageWidth>

      <QuestionContainerV2>
        <QuestionContainer>
          <QuestionContainerV2Spacing>
            <QuestionValues variants={bottomToTopItem}>
              {deliveryPreferenceData.labels.map(item => (
                <QuestionItemText
                  onClick={() => handleRatingUpdate(ratingState.q20, item.value)}
                  whileTap={{
                    scale: 0.9,
                  }}
                  key={item.value}
                  animate={getAnimateProperties(ratingState.q20, item.value)}
                >
                  {item.label}
                </QuestionItemText>
              ))}
            </QuestionValues>
          </QuestionContainerV2Spacing>
        </QuestionContainer>
      </QuestionContainerV2>

      <MessageWidth>
        <MessageSpacing>
          <Message>{relativeEvaluationData.title}</Message>
        </MessageSpacing>
      </MessageWidth>

      <QuestionContainerV2>
        <QuestionContainer>
          <QuestionContainerV2Spacing>
            <QuestionValues variants={bottomToTopItem}>
              {relativeEvaluationData.labels.map(item => (
                <QuestionItemText
                  onClick={() => handleRatingUpdate(ratingState.q21, item.value)}
                  whileTap={{
                    scale: 0.9,
                  }}
                  key={item.value}
                  animate={getAnimateProperties(ratingState.q21, item.value)}
                >
                  {item.label}
                </QuestionItemText>
              ))}
            </QuestionValues>
          </QuestionContainerV2Spacing>
        </QuestionContainer>
      </QuestionContainerV2>
    </>
  )
}

export default CompetitivePreference
